if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.mql = window.matchMedia('(min-width: 750px)');
      this.initializeColorGroups();
      if (!this.elements.thumbnails) return;

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
      });
      if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
    }

    onSlideChanged(event) {
      if (!event.detail.currentElement || !this.elements.thumbnails) return;
      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
      this.setActiveThumbnail(thumbnail);
    }

    setActiveMedia(mediaId, prepend) {
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      if (!activeMedia) return;
      this.filterColorGroup(mediaId);
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');

      if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          if (activeThumbnail) activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      if (this.colorGroups) this.resetColorSliders();

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
      });
      this.playActiveMedia(activeMedia);

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.setActiveThumbnail(activeThumbnail);
      if (activeThumbnail) this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }

    initializeColorGroups() {
      if (!this.dataset.colorGroups) return;
      const config = JSON.parse(this.dataset.colorGroups);
      const anchors = new Set(config.anchors.map(String));
      if (anchors.size < 2) return;
      this.colorGroups = new Map();
      let group = null;
      config.media.map(String).forEach((id) => {
        if (anchors.has(id)) group = id;
        if (group) this.colorGroups.set(id, group);
      });
      this.elements.viewer.querySelectorAll('.product__media-list > [data-media-id]').forEach((item) => {
        item.classList.remove('product__media-item--variant');
      });
      this.elements.thumbnails?.querySelectorAll('[data-target]').forEach((item) => {
        item.classList.remove('thumbnail-list_item--variant');
      });
      this.filterColorGroup(String(config.selected));
      this.resetColorSliders();
    }

    filterColorGroup(mediaId) {
      if (!this.colorGroups) return;
      const selected = String(mediaId).split('-').pop();
      const group = this.colorGroups.get(selected);
      if (!group) return;
      const filter = (item, id) => {
        const owner = this.colorGroups.get(String(id).split('-').pop());
        const hidden = Boolean(owner && owner !== group);
        item.hidden = hidden;
        if (hidden) item.style.setProperty('display', 'none', 'important');
        else item.style.removeProperty('display');
        if (hidden) item.classList.remove('is-active', 'active');
      };
      this.elements.viewer.querySelectorAll('.product__media-list > [data-media-id]').forEach((item) => filter(item, item.dataset.mediaId));
      this.elements.thumbnails?.querySelectorAll('[data-target]').forEach((item) => filter(item, item.dataset.target));
      const modal = document.getElementById(`ProductModal-${this.closest('section')?.dataset.section}`);
      modal?.querySelectorAll('[data-media-id]').forEach((item) => {
        item.classList.remove('product__media-item--variant', 'product__media--variant');
        filter(item, item.dataset.mediaId);
      });
    }

    resetColorSliders() {
      [this.elements.viewer, this.elements.thumbnails].filter(Boolean).forEach((slider) => {
        const items = [...slider.querySelectorAll('[id^="Slide-"]')].filter((item) => !item.hidden);
        if (!slider.slider) return;
        slider.slider.scrollTo({ left: 0, behavior: 'instant' });
        slider.resetPages();
        if (items.length === 1) {
          slider.sliderItemsToShow = items;
          slider.sliderItemOffset = Math.max(slider.slider.clientWidth, 1);
          slider.slidesPerPage = 1;
          slider.totalPages = 1;
          slider.currentPage = 1;
          if (slider.currentPageElement) slider.currentPageElement.textContent = '1';
          if (slider.pageTotalElement) slider.pageTotalElement.textContent = '1';
          slider.prevButton?.setAttribute('disabled', 'disabled');
          slider.nextButton?.setAttribute('disabled', 'disabled');
        }
        const controls = slider.querySelector('.slider-buttons');
        if (controls) controls.style.display = items.length < 2 ? 'none' : '';
      });
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
      thumbnail.querySelector('button').setAttribute('aria-current', true);
      if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

      this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}

